import * as React from "react";
import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.211 16.356l-1.125 1.266c-.214.24-.52.378-.841.378H10.5v1.875c0 .621-.504 1.125-1.125 1.125H7.5v1.875C7.5 23.496 6.996 24 6.375 24h-5.25A1.125 1.125 0 0 1 0 22.875v-3.659c0-.298.118-.585.33-.796l7.584-7.584A8.25 8.25 0 0 1 15.75 0 8.233 8.233 0 0 1 24 8.25a8.25 8.25 0 0 1-9.789 8.106z"
      fill="#9dc8d2"
      fillRule="evenodd"
      opacity=".5"
    />
  </svg>,
  "Password"
);
